//http://www.quirksmode.org/js/detect.html

class BrowserDetect {
    constructor() {
        this.dataBrowser = [
            {
                string: navigator.userAgent,
                subString: "Edge",
                identity: "Edge"
            },
            {
                string: navigator.userAgent,
                subString: "Chrome",
                identity: "Chrome"
            },
            {
                string: navigator.userAgent,
                subString: "OmniWeb",
                versionSearch: "OmniWeb/",
                identity: "OmniWeb"
            },
            {
                string: navigator.vendor,
                subString: "Apple",
                identity: "Safari",
                versionSearch: "Version"
            },
            {
                prop: window.opera,
                identity: "Opera",
                versionSearch: "Version"
            },
            {
                string: navigator.vendor,
                subString: "iCab",
                identity: "iCab"
            },
            {
                string: navigator.vendor,
                subString: "KDE",
                identity: "Konqueror"
            },
            {
                string: navigator.userAgent,
                subString: "Firefox",
                identity: "Firefox"
            },
            {
                string: navigator.vendor,
                subString: "Camino",
                identity: "Camino"
            },
            {// for newer Netscapes (6+)
                string: navigator.userAgent,
                subString: "Netscape",
                identity: "Netscape"
            },
            {
                // IE9/10
                string: navigator.userAgent,
                subString: "MSIE",
                identity: "Internet Explorer",
                versionSearch: "MSIE"
            },
            {
                // IE11
                string: navigator.userAgent,
                subString: "Trident",
                identity: "Internet Explorer",
                versionSearch: "rv"
            },
            {
                string: navigator.userAgent,
                subString: "Gecko",
                identity: "Mozilla",
                versionSearch: "rv"
            },
            {// for older Netscapes (4-)
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }
        ]

        this.dataOS = [
            {
                string: navigator.platform,
                subString: "Win",
                identity: "Windows"
            },
            {
                string: navigator.platform,
                subString: "Mac",
                identity: "Mac"
            },
            {
                string: navigator.userAgent,
                subString: "iPhone",
                identity: "iPhone/iPod"
            },
            {
                string: navigator.userAgent,
                subString: "iPad",
                identity: "iPad"
            },
            {
                string: navigator.userAgent,
                subString: "Android",
                identity: "Android"
            },
            {
                string: navigator.platform,
                subString: "Linux",
                identity: "Linux"
            }
        ];
    }

    init() {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.searchVersion(navigator.userAgent)
            || this.searchVersion(navigator.appVersion)
            || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
        //console.log("browser: " + this.browser + " - " + this.version + " - " + this.OS);
    }

    searchString(data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            var dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) !== -1) {
                    //console.log("dataString: " + dataString);
                    return data[i].identity;
                }
            }
            else if (dataProp) {
                //console.log("dataProp: " + dataProp);
                return data[i].identity;
            }
        }
    }

    searchVersion(dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1)
            return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    }

    isEdge() {
        return this.browser === "Edge";
    }

    isInternetExplorer() {
        return this.browser === 'Internet Explorer' || this.browser === 'MSIE';
    }

    isInternetExplorer9() {
        return (this.browser === 'Internet Explorer' || this.browser === 'MSIE') && this.version <= 9;
    }

    isInternetExplorer10() {
        return (this.browser === 'Internet Explorer' || this.browser === 'MSIE') && this.version == 10;
    }

    isInternetExplorer9Or10() {
        return (this.browser === 'Internet Explorer' || this.browser === 'MSIE') && this.version <= 10;
    }

    isMobile() {
        return this.OS === 'Android' || this.OS === 'iPhone' || this.OS === 'iPad' || this.OS === 'iPhone/iPod' && this.OS !== 'Windows';
    }

    isAndroid() {
        return this.OS === 'Android';
    }

    isFirefox() {
        return this.browser === 'Firefox';
    }

    isChrome() {
        return this.browser === 'Chrome';
    }

    isSafari() {
        return this.browser === 'Safari';
    }

    isIpad() {
        return this.OS === 'iPad';
    }

    isIphone() {
        return this.OS === 'iPhone' || this.OS === 'iPhone/iPod';
    }

    isIOS() {
        return this.OS === 'iPhone' || this.OS === 'iPad' || this.OS === 'iPhone/iPod';
    }

    isMac() {
        return this.OS === 'Mac';
    }

    isApple() {
        return this.browser === 'Safari' && this.OS !== 'Windows' || this.OS === 'Mac' || this.isIpad() || this.isIphone();
    }

    isWindows() {
        return this.OS === 'Windows';
    }

    isCookiesEnabled() {
        return navigator.cookieEnabled;
    }

    getPlatform() {
        var platform = null;
        switch (this.OS) {
            case "iPhone":
            case "iPad":
            case "iPhone/iPod":
                platform = "iOS";
                break;
            case "Windows":
            case "Mac":
                platform = ranj.WebsiteDetect.isFacebook() ? "Facebook" : "Standalone";
                break;
            default:
                platform = this.OS; //Android
                break;
        }
        return platform;
    }
}

const instance = new BrowserDetect();
instance.init();

export default instance;